import { BaseApi } from "./Base";

class StatsApi extends BaseApi {
  getDashboardStats(year) {
    return super.getApiRequest("/stats/dashboard", year ? { year } : undefined);
  }
}

const statsApi = new StatsApi();

export default statsApi;
